export default "__VITE_ASSET__$gb4Vlxg__"